import { Injectable } from '@angular/core';
import { Usuario } from 'src/app/models/usuario/usuario';


@Injectable()
export class GVars 
{
  readonly DISPOSITIVO_DESKTOP: number = 0;
  readonly DISPOSITIVO_MOBILE : number = 1; 

  public aplicacionCargada: boolean = false;
  public anchoResolucion: number = 0;
  public altoResolucion: number = 0;
  public tipoDispositivo: number = 0;
  public usuarioLogueado: boolean = false;
  public usuario: Usuario;

  public cursos = []; 
  public cursosObtenidos: boolean = false;
  public cursosCategorias = []; 
  public cursosCategoriasObtenidos: boolean = false;

  public libros = []; 
  public librosObtenidos: boolean = false;
  public librosCategorias = []; 
  public librosCategoriasObtenidos: boolean = false;

  public documentos = []; 
  public documentosObtenidos: boolean = false;
  public documentosCategorias = []; 
  public documentosCategoriasObtenidas: boolean = false;

  public usuarios = [];
  public usuariosObtenidos: boolean = false;

  constructor(
  ) 
  {    
  }
}
